module.exports = __webpack_public_path__ + "img/Fototanten.95df8322.jpg";